export const VIEW_MODE = {
  PC: 'PC',
  TABLET: 'TABLET',
  MOBILE: 'MOBILE',
} as const;

export type ViewModeType = keyof typeof VIEW_MODE;
